import { render } from "./assets.vue?vue&type=template&id=8aef6c04&ts=true"
import script from "./assets.vue?vue&type=script&lang=ts"
export * from "./assets.vue?vue&type=script&lang=ts"

import "./assets.vue?vue&type=style&index=0&id=8aef6c04&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__